<template>
    <div class="right_tab">
        <div v-show="$store.state.orgCode==$store.state.businessNo" @click="goRouter('/publish')">
            <div>发布</div>
            <div>商品</div>
        </div>
        <!-- <div>
            <div></div>
            <div>扫码</div>
        </div> -->
        <!-- <div>
            <div><i class="el-icon-service"></i></div>
            <div>客服</div>
        </div> -->
        <div @click="goTop">
            <div><i class="el-icon-arrow-up"></i></div>
            <div>顶部</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RightTab",
        data() {
            return {}
        },
        methods: {
            goTop() {
                this.$nextTick(() => {
                    window.scrollTo(0, 0);
                })
            }
        }
    };
</script>

<style scoped>
    .right_tab {
        position: fixed;
        right: 12px;
        top: calc(50% - 70px);
        width: 86px;
        padding: 0 6px;
        box-sizing: border-box;
        text-align: center;
        background: #FFFFFF;
    }

    .right_tab>div {
        height: 70px;
        border-bottom: 1px solid #D8E0ED;
        padding: 12px 0;
        box-sizing: border-box;
        cursor: pointer;
    }

    .right_tab>div:last-child {
        border: none;
    }

    .right_tab>div>div {
        font-size: 16px;
        color: #333333;
        line-height: 20px;
    }

    .right_tab>div:nth-child(1)>div {
        font-weight: bold;
        color: #D50000;
    }

    .right_tab>div>div:nth-child(1) {
        font-size: 24px;
    }

    .right_tab>div:nth-child(1)>div:nth-child(1) {
        font-size: 16px;
    }

    .right_tab>div:nth-child(1)>div:nth-child(2) {
        margin-top: 2px;
    }
</style>



// WEBPACK FOOTER //
// src/components/RightTab.vue